import { store, getContext } from '@wordpress/interactivity';

store('sms-medipool/search-toggle', {
    actions: {
        toggle: () => {
            const context = getContext();
            context.isOpen = !context.isOpen;
        },
        close: () => {
            const context = getContext();
            context.isOpen = false;
        },
        onKeydown: (args = {}) => {
            if (!args.key || args.key !== 'Escape') {
                return;
            }
            // Close directly without relying on injected actions to avoid undefined errors
            const context = getContext();
            context.isOpen = false;
        },
    },
    callbacks: {
        focusInput: ({ ref }) => {
            // focus the first input inside the modal when opened (after it becomes visible)
            const input = ref?.querySelector('input, [type="search"]');
            if (input) {
                requestAnimationFrame(() => input.focus());
            }
        },
    },
});
